import { NgModule } from '@angular/core';
import { DocumentDisplayService } from "./document-display.service";

@NgModule({
	imports: [

	],
	declarations: [

	],
	exports: [
	],
	providers: [
		DocumentDisplayService
	]
})
export class DocumentModule {
	static forRoot() {
		return {
			ngModule: DocumentModule
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/documents/document.module.ts